var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.6897,
    height: 40.6897,
    rx: 9,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3457 25.3447V28.3447C9.3457 28.897 9.79342 29.3447 10.3457 29.3447H24.3457C24.898 29.3447 25.3457 28.897 25.3457 28.3447V25.3447C25.3457 23.1356 23.5548 21.3447 21.3457 21.3447H13.3457C11.1366 21.3447 9.3457 23.1356 9.3457 25.3447Z",
    fill: "url(#paint0_linear_3638_172958)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3301 28.6565C27.2947 28.9998 27.5374 29.3447 27.8825 29.3447H30.3461C30.8984 29.3447 31.3461 28.897 31.3461 28.3447V25.3447C31.3461 23.1356 29.5553 21.3447 27.3461 21.3447H26.3776C26.1615 21.3447 26.0429 21.6044 26.1715 21.7781C26.9096 22.7751 27.3461 24.009 27.3461 25.3447V28.3447C27.3461 28.45 27.3407 28.554 27.3301 28.6565Z",
    fill: "url(#paint1_linear_3638_172958)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3457 15.3447C21.3457 17.5539 19.5548 19.3447 17.3457 19.3447C15.1366 19.3447 13.3457 17.5539 13.3457 15.3447C13.3457 13.1356 15.1366 11.3447 17.3457 11.3447C19.5548 11.3447 21.3457 13.1356 21.3457 15.3447Z",
    fill: "url(#paint2_linear_3638_172958)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6963 19.2923C22.3556 19.2367 22.2394 18.834 22.4236 18.542C23.0076 17.6164 23.3456 16.52 23.3456 15.3447C23.3456 14.1694 23.0076 13.073 22.4236 12.1474C22.2394 11.8555 22.3556 11.4528 22.6963 11.3971C22.9076 11.3627 23.1245 11.3447 23.3456 11.3447C25.5547 11.3447 27.3456 13.1356 27.3456 15.3447C27.3456 17.5539 25.5547 19.3447 23.3456 19.3447C23.1245 19.3447 22.9076 19.3268 22.6963 19.2923Z",
    fill: "url(#paint3_linear_3638_172958)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3638_172958",
    x1: 17.3457,
    y1: 21.3447,
    x2: 17.3457,
    y2: 29.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE1E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3638_172958",
    x1: 28.5823,
    y1: 21.3447,
    x2: 28.5823,
    y2: 29.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE1E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3638_172958",
    x1: 17.3457,
    y1: 11.3447,
    x2: 17.3457,
    y2: 19.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE1E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3638_172958",
    x1: 24.6786,
    y1: 11.3447,
    x2: 24.6786,
    y2: 19.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE1E0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAts);
export default __webpack_public_path__ + "static/media/ats.a156ee51168780403763651d1955f971.svg";
export { ForwardRef as ReactComponent };